import * as React from 'react';
import { Container, PagConfiguracoes, TituloSecao } from '../styles';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fa0, faExpand, faExpandArrowsAlt, faEye, faImage, faLemon, faLink } from '@fortawesome/free-solid-svg-icons';

const Layout: React.FC = () => {
 
  return (
    <Container>
      <TituloSecao>
      Layout
      </TituloSecao>

      <PagConfiguracoes>
                <a href='/configuracao/layoutcores' className="links">
                    <div className="links">
                        <FontAwesomeIcon className='icon' icon={faImage} size={"2x"} />
                        <p>Edição de Cores</p>
                    </div>
                </a>

                <a href='/configuracao/cdlogo' className="links">
                    <div className="links">
                        <FontAwesomeIcon className='icon' icon={faEye} size={"2x"} />
                        <p>Edição de Logo</p>
                    </div>
                </a>

            </PagConfiguracoes>
    </Container>
  )
};

export default Layout;